/**
 * Converts rgb to rgba
 *
 * this can be used to add and adjust opacity to a color
 *
 * @example convertRgbToRgba('rgb(242, 71, 71)', 0.5) => 'rgba(242, 71, 71, 0.5)'
 * @param {string} rgb
 * @param {number} opacity
 */
export const convertRgbToRgba = (
  rgb: string,
  opacity: 0 | 0.1 | 0.2 | 0.3 | 0.4 | 0.5 | 0.6 | 0.7 | 0.8 | 0.9 | 1 = 1,
) => {
  return rgb.replace('rgb', 'rgba').replace(')', ', ' + opacity + ')')
}
